import { makeHook } from "../../utils/makeSingleArgHook";
import getAccountGroups, { queryKeyAGs, } from "../requests/getAccountGroups";
const useAccountGroups = makeHook(getAccountGroups, (body) => queryKeyAGs(body));
export default useAccountGroups;
//# sourceMappingURL=useAccountGroups.js.map